/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import { DropDownContainer, DropDownWrapper, DropDownButton, Label, MenuWrapper, MenuItem, DropdownArrow, ErrorMessage, FadedText, Anchor } from "./Dropdown/Dropdown";
import { get } from "lodash-es";
import RemovableItem from "./RemovableItem/index";

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      cursor: 0,
      keys: Object.keys(get(props, "list", {})),
      tag: "",
      selectedItems: {},
      displayList: get(props, "list", {}),
      displayKeys: Object.keys(get(props, "list", {}))
    };
    this.ref = React.createRef();
    let selfClick = false; // Used to fix onBlur being triggered when selecting a child
    // console.log("XXX :  Dropdown constructor  ",this.state.displayKeys,  this.state.displayList)
  }

  componentWillMount() {
    this.getSelectedItems();
  }
  // componentDidMount() {
  //   this.getSelectedItems();
  // }

  componentDidUpdate(prevProps, prevState) {
    const { multiselect } = this.props;

    // If the menu changes state and we're in a multiselect dropdown
    if (prevState.menu !== this.state.menu && multiselect) {
      if (multiselect && this.state.cursor !== 0) {
        this.setState({ cursor: 0 });
      }
    }

    // if(this.didObjChange(prevProps.list, this.props.list)) {
    if (prevProps.list != this.props.list) {
      this.setState({displayList: get(this.props, "list", {}),})
      this.setState({displayKeys: Object.keys(get(this.props, "list", {}))});
    }
 
    // console.log("XXX : componentDidUpdate ", prevProps, this.props)  
  }

  getSelectedItems() {
    const { multiselect, value } = this.props;
    // console.log("XXX : getSelectedItems ", this.props)
    if (multiselect && value) {
      let newObj = {};
      value.forEach((item, i) => {
        if (!newObj[item]) newObj[item] = true;
      });
      this.setState({ selectedItems: newObj }, () => {
        this.updateDisplayKeys();
      });
    }
  }

  // Gets the position of the passed value and sets the cursor to it
  getInitialCursorValue() {
    const { value, list } = this.props;
    const { displayKeys } = this.state;

    for (let i = 0; i < displayKeys.length; i++) {
      if (list[displayKeys[i]] === value) {
        this.setState({ cursor: i });
      }
    }
  }

  // Creates a unique ID for the component
  makeid(length) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  componentWillMount() {
    this.setState({ tag: this.makeid(5) });
    this.getInitialCursorValue();
  }

  componentWillUnmount() {
    this.removeListener(); // Remove click listener in case it's still there
  }

  // Attempts to remove click listener (if any)
  removeListener() {
    try {
      document.removeEventListener("mousedown", this.handleFocusClick);
    } catch (err) { }
  }

  // Actions to take on click
  handleClick(type) {
    try {
      const { menu, displayKeys } = this.state;

      if(this.props.disabled) { return;}

      if (!menu) {
        this.setState({ menu: true }, () => {
          if (displayKeys.length > 1) this.checkItemOverflow();
        });
        document.addEventListener("mousedown", this.handleFocusClick);
      } // Add click listener
      else {
        if (this.selfClick && type !== "focus") {
          this.closeMenu();
        }
      }
    } catch (err) { }
  }

  // What to do when element isn't focused
  blurHit() {
    // If we're not clicking a child elem, then close the menu
    if (!this.selfClick) this.closeMenu();
  }

  // Determins if we're clikcing on clicking on this element or not
  handleFocusClick = (e) => {
    try {
      if (!this.ref.current.contains(e.target)) this.selfClick = false;
      else this.selfClick = true;
    } catch (err) {
      console.log("err: ", err);
    }
  };

  // Closes menu and removes listener
  closeMenu() {
    this.setState({ menu: false }, () => {
      this.selfClick = false;
    });
    this.removeListener();
  }

  // Removes item from multiselect list
  removeItem(e, key) {
    const { selectedItems } = this.state;
    e.stopPropagation();
    if (selectedItems[key]) {
      let obj = { ...selectedItems };
      delete obj[key];
      this.setState({ selectedItems: obj }, () => {
        this.updateDisplayKeys();
      });
    }
  }

  // Updates the visible options displayed to the user (only relevant for multiselect dropdowns)
  updateDisplayKeys(type, key) {
    const { list } = this.props;
    // console.log("XXX : list if importer ", list)
    const { selectedItems } = this.state;

    let newObj = { ...selectedItems };
    let newList = { ...list };
    if (type === "add") newObj[key] = true;

    Object.keys(newList).forEach((item, i) => {
      if (newObj[item]) delete newList[item];
    });

    this.setState({ selectedItems: newObj, displayList: newList, displayKeys: Object.keys(newList) }, () => {
      let res = [];
      Object.keys(this.state.selectedItems).forEach((key) => res.push(key));
      this.props.handleSelect(res);
    });
  }

  // When a menu item is selected
  handleChange = (e, selectedValue, i) => {
    // console.log("Handle change : ",selectedValue, " ... ", this.state.displayList[selectedValue])
    const { multiselect } = this.props;
    e.stopPropagation();
    if (multiselect) this.updateDisplayKeys("add", this.state.displayList[selectedValue]);
    else this.props.handleSelect(selectedValue);
    this.setState({ cursor: i }, () => {
      this.closeMenu();
    });
  };

  // Keypress logic
  handleKeyPress({ key }) {
    try {
      const { multiselect } = this.props;
      const { cursor, displayKeys } = this.state;

      // Enter key pressed
      if (key === "Enter") {
        if (multiselect) {
          this.handleChange({}, displayKeys[cursor], 0);
        } else {
          this.props.handleSelect(displayKeys[cursor]);
          this.closeMenu();
        }
      }

      // Up arrow key pressed & we're not at the beginning of the dropdown list
      if (key === "ArrowUp" && cursor > 0) {
        this.setState({ cursor: cursor - 1 }, () => {
          if (displayKeys.length > 1) this.checkItemOverflow();
        });
      }

      // Down arrow key pressed & we're not at the end of the dropdown list
      if (key === "ArrowDown" && cursor < displayKeys.length - 1) {
        this.setState({ cursor: cursor + 1 }, () => {
          if (displayKeys.length > 1) this.checkItemOverflow();
        });
      }
    } catch (err) {
      console.log("caught err: ", err);
    }
  }

  // Checks if there are items above/below current dropdown view
  checkItemOverflow() {
    try {
      const { cursor, tag } = this.state;

      let menu = document.getElementById("dropdown_" + tag);
      let item = document.getElementById("item_" + tag + cursor);

      if (item.getBoundingClientRect().bottom > menu.getBoundingClientRect().top + menu.getBoundingClientRect().height || item.getBoundingClientRect().top < menu.getBoundingClientRect().top) {
        item.scrollIntoView(true);
      }
    } catch (err) {
      console.log("caught err: ", err);
    }
  }

  render() {
    const { list, label, topLabel, value, singleElement, rounded, topElement, bottomElement, leftElement, rightElement, rowElement, style, dropdownStyle, arrowStyle, phone, hasError, tabIndex, id, multiselect } = this.props;
    const { cursor, tag, menu, displayList, displayKeys, selectedItems } = this.state;
    // console.log("XXX : Dropdown : ", label, " selected item : ",selectedItems, " multiselect : ", multiselect,this.props.list, " displayKeys :  ", displayKeys)

    let dropDownChangedStyles = {...dropdownStyle};

    if(this.props.disabled)
      dropDownChangedStyles.backgroundColor = "#ccc";

    return (
      <DropDownContainer ref={this.ref} topLabel={topLabel} style={style} id={id}>
        {
          label &&
          <Label topLabel={topLabel} hasError={hasError} rounded={rounded}>
            {label}
            {hasError && rounded && <ErrorMessage>: {hasError.message}</ErrorMessage>}
          </Label>
        }

        <DropDownWrapper onKeyDown={(e) => this.handleKeyPress(e)} onClick={() => this.handleClick("onclick")} onFocus={() => this.handleClick("focus")} onBlur={() => this.blurHit()}>
          <DropDownButton style={dropDownChangedStyles} singleElement={singleElement} topElement={topElement} topLabel={topLabel} phone={phone} rounded={rounded} bottomElement={bottomElement} leftElement={leftElement} rightElement={rightElement} rowElement={rowElement} selected={this.state.menu} hasError={hasError} tabIndex={tabIndex || 0} multiselect={multiselect}>
            {multiselect ? (
              Object.keys(selectedItems).map((item) => {
                // console.log("XXX : Dropdown removable item : ", item)
                return <RemovableItem item={item} value={item} onClick={(e, key) => this.removeItem(e, key)} />;
              })
            ) : value && value !== "" && value !== "" ? (
              value
            ) : (
                  <FadedText>{list[0]}</FadedText>
            )}
            <Anchor>
              {menu && displayKeys.length > 0 && (
                <MenuWrapper id={"dropdown_" + tag}>
                  {displayKeys.map((elem, i) => {
                    return (
                      <MenuItem id={"item_" + tag + i} onClick={(e) => this.handleChange(e, elem, i)} value={elem} key={i} singleElement={displayKeys.length === 1} bottomElement={i === displayKeys.length - 1} isFocused={cursor === i ? true : false}>
                        {displayList[elem]}
                      </MenuItem>
                    );
                  })}
                </MenuWrapper>
              )}
            </Anchor>
          </DropDownButton>
          <DropdownArrow onClick={() => this.handleClick("icon")} className={"angle down icon"} style={arrowStyle} />
        </DropDownWrapper>
      </DropDownContainer>
    );
  }
}

export default Dropdown;
